import * as React from "react";
import { useContext, useReducer } from "react";
var initialState = {
  messages: []
};
export var FeedbackContext = /*#__PURE__*/React.createContext(null);
export var FeedbackProvider = function (_a) {
  var reducer = _a.reducer,
    children = _a.children;
  return /*#__PURE__*/React.createElement(FeedbackContext.Provider, {
    value: useReducer(reducer, initialState)
  }, children);
};
export var useFeedbackValue = function () {
  return useContext(FeedbackContext);
};